// Service.jsx
import './style/service.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function Service() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const services = [
    { icon: 'bi-eye', title: 'Visual Branding', description: 'Creating a strong and consistent visual identity for your brand.' },
    { icon: 'bi-people', title: 'Brand Activation', description: 'Bring your brand to life through interactive experiences with your audience.' },
    { icon: 'bi-star', title: 'Influencer / KOL Campaign', description: 'Increase brand awareness through relevant influencers and KOLs.' },
    { icon: 'bi-camera-video', title: 'Content Production', description: 'Creating high-quality content for social media and digital campaigns.' },
    { icon: 'bi-chat-dots', title: 'Social Media Management', description: 'Manage social media with the right strategy for maximum engagement.' },
  ];

  return (
    <section id="service" className="service-section">
      <div className="container">
        <h2 data-aos="fade-up" className="service-title">Our Services</h2>
        <hr className="whyus-hr" data-aos="zoom-in" data-aos-delay="200" />

        <div className="row-services">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <i className={`bi ${service.icon} service-icon`}></i>
              <div className="card-body">
                <h5 className="card-title">{service.title}</h5>
                <p className="card-text">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Service;
